export default [{
  "text": "餐娱类",
  "value": "A001",
  "children": [{
    "text": "餐饮、宾馆、娱乐、珠宝金饰、工艺美术品类",
    "value": "AA01",
    "children": [{
      "text": "(5811)包办伙食、宴会承包商",
      "value": "5811"
    }, {
      "text": "(5812)就餐场所和餐馆（包括快餐）",
      "value": "5812"
    }, {
      "text": "(5813)饮酒场所－酒吧、夜总会、茶馆、咖啡馆",
      "value": "5813"
    }, {
      "text": "(5932)古玩店-销售、维修和修复服务",
      "value": "5932"
    }, {
      "text": "(5944)银器商店",
      "value": "5944"
    }, {
      "text": "(5950)玻璃器皿和水晶饰品店",
      "value": "5950"
    }, {
      "text": "(5971)艺术商和画廊",
      "value": "5971"
    }, {
      "text": "(7012)分时使用的别墅或度假用房",
      "value": "7012"
    }, {
      "text": "(7032)运动和娱乐露营地",
      "value": "7032"
    }, {
      "text": "(7631)手表、钟表和首饰维修店",
      "value": "7631"
    }, {
      "text": "(7829)电影和录像创作发行",
      "value": "7829"
    }, {
      "text": "(7911)歌舞厅、KTV",
      "value": "7911"
    }, {
      "text": "(7922)戏剧制片（不含电影）、演出和票务",
      "value": "7922"
    }, {
      "text": "(7929)未列入其他代码的乐队、文艺表演",
      "value": "7929"
    }, {
      "text": "(7298)美容、SPA",
      "value": "7298"
    }, {
      "text": "(7932)台球、撞球场所",
      "value": "7932"
    }, {
      "text": "(7941)商业体育场馆、职业体育俱乐部、运动场和体育推广公司",
      "value": "7941"
    }, {
      "text": "(7992)公共高尔夫球场",
      "value": "7992"
    }, {
      "text": "(7996)游乐园、马戏团、嘉年华、占卜",
      "value": "7996"
    }, {
      "text": "(7997)健身、各种俱乐部、私人高尔夫课程",
      "value": "7997"
    }, {
      "text": "(7998)水族馆、海洋馆",
      "value": "7998"
    }, {
      "text": "(7999)未列入其他代码的娱乐服务",
      "value": "7999"
    }, {
      "text": "(5094)贵重珠宝、首饰，钟表零售",
      "value": "5094"
    }, {
      "text": "(5937)古玩复制店",
      "value": "5937"
    }, {
      "text": "(5970)工艺美术商店",
      "value": "5970"
    }, {
      "text": "(7011)住宿服务",
      "value": "7011"
    }, {
      "text": "(7033)活动房车及露营场所",
      "value": "7033"
    }, {
      "text": "(7297)洗浴、按摩服务",
      "value": "7297"
    }, {
      "text": "(7933)保龄球馆",
      "value": "7933"
    }, {
      "text": "(7994)大型游戏机和游戏场所",
      "value": "7994"
    }]
  }, {
    "text": "房产汽车类",
    "value": "AA02",
    "children": [{
      "text": "(1771)建设工程",
      "value": "1771"
    }, {
      "text": "(5271)活动房车销售",
      "value": "5271"
    }, {
      "text": "(5511)新旧汽车销售",
      "value": "5511"
    }, {
      "text": "(5551)船只销售商",
      "value": "5551"
    }, {
      "text": "(5561)旅行拖车、娱乐用车销售商",
      "value": "5561"
    }, {
      "text": "(5598)雪车商",
      "value": "5598"
    }, {
      "text": "(5599)汽车、飞行器、农用机车综合经营商",
      "value": "5599"
    }, {
      "text": "(7013)不动产代理——房地产经纪",
      "value": "7013"
    }, {
      "text": "(5933)典当、拍卖、信托",
      "value": "5933"
    }, {
      "text": "(5571)摩托车商店和经销商",
      "value": "5571"
    }, {
      "text": "(1520)住宅与商业楼销售",
      "value": "1520"
    }, {
      "text": "(5521)汽车货车经销商－专门从事旧车的销售",
      "value": "5521"
    }, {
      "text": "(5592)露营、房车销售商",
      "value": "5592"
    }, {
      "text": "(6012)金融机构－商品和服务",
      "value": "6012"
    }]
  }]
}, {
  "text": "一般类",
  "value": "A002",
  "children": [{
    "text": "批发类商户",
    "value": "AB01",
    "children": [{
      "text": "(5072)五金器材及用品（批发商）",
      "value": "5072"
    }, {
      "text": "(5074)管道和供暖设备（批发商）",
      "value": "5074"
    }, {
      "text": "(5111)文具/办公用品/复印纸/书写纸（批发商）",
      "value": "5111"
    }, {
      "text": "(5122)药品和药品经营者（批发商）",
      "value": "5122"
    }, {
      "text": "(5131)布料、缝纫用品和其他纺织品（批发商）",
      "value": "5131"
    }, {
      "text": "(5137)男女及儿童制服和服装（批发商）",
      "value": "5137"
    }, {
      "text": "(5139)鞋类（批发商）",
      "value": "5139"
    }, {
      "text": "(5172)石油及石油产品（批发商）",
      "value": "5172"
    }, {
      "text": "(5192)书、期刊和报纸（批发商）",
      "value": "5192"
    }, {
      "text": "(5193)花木栽种用品、苗木和花卉（批发商）",
      "value": "5193"
    }, {
      "text": "(5198)油漆、清漆用品（批发商）",
      "value": "5198"
    }, {
      "text": "(5998)其他批发商",
      "value": "5998"
    }, {
      "text": "(4458)烟草配送",
      "value": "4458"
    }, {
      "text": "(5021)办公及商务家具（批发商）",
      "value": "5021"
    }, {
      "text": "(5044)办公、影印及萎缩摄影器材（批发商）",
      "value": "5044"
    }, {
      "text": "(5045)计算机、计算机外围设备（批发商）",
      "value": "5045"
    }, {
      "text": "(5046)未列入其他代码的商用器材（批发商）",
      "value": "5046"
    }, {
      "text": "(5051)金属器材及用品（批发商）",
      "value": "5051"
    }, {
      "text": "(5065)电器零件和设备（批发商）",
      "value": "5065"
    }, {
      "text": "(5013)机动车供应及零配件（批发商）",
      "value": "5013"
    }, {
      "text": "(5398)大型企业批发",
      "value": "5398"
    }, {
      "text": "(5039)未列入其他代码的建材批发（批发商）",
      "value": "5039"
    }, {
      "text": "(5047)牙科/实验室/医疗/眼科医院器材和用品（批发商）",
      "value": "5047"
    }]
  }, {
    "text": "百货、中介、培训、景区门票等",
    "value": "AB02",
    "children": [{
      "text": "(4733)大型景区售票",
      "value": "4733"
    }, {
      "text": "(4722)旅行社",
      "value": "4722"
    }, {
      "text": "(5814)快餐店",
      "value": "5814"
    }, {
      "text": "(0742)兽医服务",
      "value": "742"
    }, {
      "text": "(0763)农业合作",
      "value": "763"
    }, {
      "text": "(0780)景观美化及园艺服务",
      "value": "780"
    }, {
      "text": "(4011)铁路运输",
      "value": "4011"
    }, {
      "text": "(4119)救护车服务",
      "value": "4119"
    }, {
      "text": "(4214)货物搬运和托运（速递）",
      "value": "4214"
    }, {
      "text": "(4215)快递服务（空运、地面运输或海运）",
      "value": "4215"
    }, {
      "text": "(4225)公共仓储服务",
      "value": "4225"
    }, {
      "text": "(4411)轮船及巡游航线服务",
      "value": "4411"
    }, {
      "text": "(4457)出租船只",
      "value": "4457"
    }, {
      "text": "(4468)船舶、海运服务提供商",
      "value": "4468"
    }, {
      "text": "(4582)机场服务",
      "value": "4582"
    }, {
      "text": "(4789)未列入其它代码的运输服务",
      "value": "4789"
    }, {
      "text": "(4812)通讯设备（电话销售）",
      "value": "4812"
    }, {
      "text": "(4816)计算机网络/信息服务",
      "value": "4816"
    }, {
      "text": "(4821)电报服务",
      "value": "4821"
    }, {
      "text": "(5211)木材和建材卖场",
      "value": "5211"
    }, {
      "text": "(5231)玻璃、油漆、壁纸商店",
      "value": "5231"
    }, {
      "text": "(5251)五金商店",
      "value": "5251"
    }, {
      "text": "(5261)草坪、花园品商店",
      "value": "5261"
    }, {
      "text": "(5309)免税商店",
      "value": "5309"
    }, {
      "text": "(5310)折扣商店",
      "value": "5310"
    }, {
      "text": "(5311)百货商店",
      "value": "5311"
    }, {
      "text": "(5331)各类杂货店、便利店",
      "value": "5331"
    }, {
      "text": "(5399)其他综合零售",
      "value": "5399"
    }, {
      "text": "(5422)冷藏、储藏肉类供应商",
      "value": "5422"
    }, {
      "text": "(5441)糖果店、坚果店",
      "value": "5441"
    }, {
      "text": "(5451)乳制品店、冷饮店",
      "value": "5451"
    }, {
      "text": "(5462)面包铺",
      "value": "5462"
    }, {
      "text": "(5499)各类食品店及专门食品零售店",
      "value": "5499"
    }, {
      "text": "(5532)汽车轮胎商店",
      "value": "5532"
    }, {
      "text": "(5533)汽车零件配件商店",
      "value": "5533"
    }, {
      "text": "(5611)男子和男童服装及附件商店",
      "value": "5611"
    }, {
      "text": "(5621)妇女时装商店",
      "value": "5621"
    }, {
      "text": "(5631)妇女专用品商店",
      "value": "5631"
    }, {
      "text": "(5641)儿童婴儿用品商店",
      "value": "5641"
    }, {
      "text": "(5651)家庭服装商店",
      "value": "5651"
    }, {
      "text": "(5655)运动服饰商店",
      "value": "5655"
    }, {
      "text": "(5661)鞋店",
      "value": "5661"
    }, {
      "text": "(5681)皮货商店",
      "value": "5681"
    }, {
      "text": "(5691)男女成衣店",
      "value": "5691"
    }, {
      "text": "(5697)裁缝、修补、改衣店",
      "value": "5697"
    }, {
      "text": "(5698)假发商店",
      "value": "5698"
    }, {
      "text": "(5699)各类服饰及饰物店",
      "value": "5699"
    }, {
      "text": "(5712)家具、家用设备零售商",
      "value": "5712"
    }, {
      "text": "(5713)地板商店",
      "value": "5713"
    }, {
      "text": "(5714)帏帐、窗帘、室内装潢商店",
      "value": "5714"
    }, {
      "text": "(5718)壁炉、壁炉防护网及配件商店",
      "value": "5718"
    }, {
      "text": "(5719)各种家庭装饰专营店",
      "value": "5719"
    }, {
      "text": "(5732)家用电器商店",
      "value": "5732"
    }, {
      "text": "(5733)音乐商店-乐器、钢琴、乐谱",
      "value": "5733"
    }, {
      "text": "(5734)计算机软件商店",
      "value": "5734"
    }, {
      "text": "(5735)音像制品商店",
      "value": "5735"
    }, {
      "text": "(5912)药店",
      "value": "5912"
    }, {
      "text": "(5921)瓶装酒零售店",
      "value": "5921"
    }, {
      "text": "(5931)旧商品店、二手商品店",
      "value": "5931"
    }, {
      "text": "(5935)海上船只遇难救助",
      "value": "5935"
    }, {
      "text": "(5940)自行车商店",
      "value": "5940"
    }, {
      "text": "(5941)体育用品店",
      "value": "5941"
    }, {
      "text": "(5942)书店",
      "value": "5942"
    }, {
      "text": "(5943)文具店，办公室、学校用品商店",
      "value": "5943"
    }, {
      "text": "(5945)玩具、游戏店",
      "value": "5945"
    }, {
      "text": "(5946)照相器材店",
      "value": "5946"
    }, {
      "text": "(5947)礼品、卡片、装饰品、纪念品商店",
      "value": "5947"
    }, {
      "text": "(5948)箱包、皮具店",
      "value": "5948"
    }, {
      "text": "(5949)纺织品及针织品零售",
      "value": "5949"
    }, {
      "text": "(5962)旅游相关服务直销",
      "value": "5962"
    }, {
      "text": "(5963)门对门销售",
      "value": "5963"
    }, {
      "text": "(5964)目录销售商户",
      "value": "5964"
    }, {
      "text": "(5965)目录、零售兼营商户",
      "value": "5965"
    }, {
      "text": "(5966)电话呼出直销",
      "value": "5966"
    }, {
      "text": "(5967)电话呼入直销",
      "value": "5967"
    }, {
      "text": "(5968)订阅/订购直销服务",
      "value": "5968"
    }, {
      "text": "(5969)其他直销商户",
      "value": "5969"
    }, {
      "text": "(5972)邮票和纪念币商店",
      "value": "5972"
    }, {
      "text": "(5973)宗教品商店",
      "value": "5973"
    }, {
      "text": "(5975)助听器-销售、服务和用品",
      "value": "5975"
    }, {
      "text": "(5976)医疗器械",
      "value": "5976"
    }, {
      "text": "(5977)化妆品店",
      "value": "5977"
    }, {
      "text": "(5978)打字机商店-销售、服务和出租",
      "value": "5978"
    }, {
      "text": "(5983)燃料经销商-燃油、木材、煤炭和液化石油气",
      "value": "5983"
    }, {
      "text": "(5992)花店",
      "value": "5992"
    }, {
      "text": "(5995)宠物商店、宠物食品及用品",
      "value": "5995"
    }, {
      "text": "(5996)游泳池-销售、供应和服务",
      "value": "5996"
    }, {
      "text": "(5997)电动剃须刀商店-销售和服务",
      "value": "5997"
    }, {
      "text": "(6010)金融机构－人工现金支付",
      "value": "6010"
    }, {
      "text": "(6211)证券公司－经纪人和经销商",
      "value": "6211"
    }, {
      "text": "(6513)不动产管理-物业管理",
      "value": "6513"
    }, {
      "text": "(7210)洗衣店",
      "value": "7210"
    }, {
      "text": "(7211)洗熨服务（自助洗衣服务）",
      "value": "7211"
    }, {
      "text": "(7216)干洗店",
      "value": "7216"
    }, {
      "text": "(7217)市内清洁服务",
      "value": "7217"
    }, {
      "text": "(7221)照相馆",
      "value": "7221"
    }, {
      "text": "(7230)理发店",
      "value": "7230"
    }, {
      "text": "(7251)修鞋店、擦鞋店、帽子清洗店",
      "value": "7251"
    }, {
      "text": "(7261)丧仪殡葬服务",
      "value": "7261"
    }, {
      "text": "(7273)婚姻介绍",
      "value": "7273"
    }, {
      "text": "(7276)水手准备服务",
      "value": "7276"
    }, {
      "text": "(7277)咨询服务—债务、婚姻和个人私事",
      "value": "7277"
    }, {
      "text": "(7278)购物服务及会所（贸易、经济服务）",
      "value": "7278"
    }, {
      "text": "(7295)家政服务",
      "value": "7295"
    }, {
      "text": "(7296)出租衣物",
      "value": "7296"
    }, {
      "text": "(7299)未列入其它代码的其他个人服务",
      "value": "7299"
    }, {
      "text": "(7311)广告服务",
      "value": "7311"
    }, {
      "text": "(7321)消费者信用报告机构",
      "value": "7321"
    }, {
      "text": "(7333)商业摄影服务",
      "value": "7333"
    }, {
      "text": "(7338)复印及绘图服务",
      "value": "7338"
    }, {
      "text": "(7339)速记和秘书类服务",
      "value": "7339"
    }, {
      "text": "(7342)灭虫及消毒服务",
      "value": "7342"
    }, {
      "text": "(7349)清洁、保养、门卫服务",
      "value": "7349"
    }, {
      "text": "(7361)职业中介、临时工",
      "value": "7361"
    }, {
      "text": "(7372)计算机编程、数据处理和系统集成设计服务",
      "value": "7372"
    }, {
      "text": "(7375)信息检索服务",
      "value": "7375"
    }, {
      "text": "(7379)未列入其他代码的计算机维护和修理服务",
      "value": "7379"
    }, {
      "text": "(7392)管理、咨询和公共关系服务",
      "value": "7392"
    }, {
      "text": "(7393)侦探、保安、安全服务",
      "value": "7393"
    }, {
      "text": "(7394)设备、工具、家俱和电器出租",
      "value": "7394"
    }, {
      "text": "(7395)照相洗印服务",
      "value": "7395"
    }, {
      "text": "(7399)未列入其它代码的商业服务",
      "value": "7399"
    }, {
      "text": "(7512)汽车出租",
      "value": "7512"
    }, {
      "text": "(7513)卡车及拖车出租",
      "value": "7513"
    }, {
      "text": "(7519)房车和娱乐车辆出租",
      "value": "7519"
    }, {
      "text": "(7531)车体维修店",
      "value": "7531"
    }, {
      "text": "(7534)轮胎翻新、维修店",
      "value": "7534"
    }, {
      "text": "(7535)汽车喷漆店",
      "value": "7535"
    }, {
      "text": "(7538)汽车维修、服务商店（非经销商）",
      "value": "7538"
    }, {
      "text": "(7542)洗车",
      "value": "7542"
    }, {
      "text": "(7549)拖车服务",
      "value": "7549"
    }, {
      "text": "(7622)电器维修",
      "value": "7622"
    }, {
      "text": "(7623)空调及冷藏设备维修店",
      "value": "7623"
    }, {
      "text": "(7629)家电维修店",
      "value": "7629"
    }, {
      "text": "(7641)家具维修、翻新",
      "value": "7641"
    }, {
      "text": "(7692)焊接维修服务",
      "value": "7692"
    }, {
      "text": "(7699)各类维修店及相关服务",
      "value": "7699"
    }, {
      "text": "(7832)电影院",
      "value": "7832"
    }, {
      "text": "(7841)出租录像带服务",
      "value": "7841"
    }, {
      "text": "(7991)旅游与展览",
      "value": "7991"
    }, {
      "text": "(7993)电子游戏供给",
      "value": "7993"
    }, {
      "text": "(7995)博彩业（包括彩票等）",
      "value": "7995"
    }, {
      "text": "(8011)未列入其它代码的医生和医师",
      "value": "8011"
    }, {
      "text": "(8021)牙科医生、整牙医生",
      "value": "8021"
    }, {
      "text": "(8031)正骨医生",
      "value": "8031"
    }, {
      "text": "(8041)按摩医生、盲人按摩",
      "value": "8041"
    }, {
      "text": "(8042)眼光配镜师、眼科医生",
      "value": "8042"
    }, {
      "text": "(8043)光学仪器商、光学产品和眼镜商",
      "value": "8043"
    }, {
      "text": "(8049)手足病医生",
      "value": "8049"
    }, {
      "text": "(8050)护理和照料服务",
      "value": "8050"
    }, {
      "text": "(8071)医学和牙科实验室",
      "value": "8071"
    }, {
      "text": "(8099)未列入其它代码的医疗保健服务",
      "value": "8099"
    }, {
      "text": "(8111)法律服务",
      "value": "8111"
    }, {
      "text": "(8241)函授学校",
      "value": "8241"
    }, {
      "text": "(8244)商业和文秘学校（中等专业学校）",
      "value": "8244"
    }, {
      "text": "(8249)贸易和职业学校（职业技能培训）",
      "value": "8249"
    }, {
      "text": "(8299)未列入其它代码的学校与教育服务",
      "value": "8299"
    }, {
      "text": "(8351)儿童保育服务",
      "value": "8351"
    }, {
      "text": "(8641)市民、社会及友爱组织",
      "value": "8641"
    }, {
      "text": "(8661)宗教组织",
      "value": "8661"
    }, {
      "text": "(8675)汽车协会",
      "value": "8675"
    }, {
      "text": "(8699)未列入其它代码的会员组织",
      "value": "8699"
    }, {
      "text": "(8911)建筑、工程和测量服务",
      "value": "8911"
    }, {
      "text": "(8912)装修、装潢、园艺",
      "value": "8912"
    }, {
      "text": "(8931)会计、审计、财务服务",
      "value": "8931"
    }, {
      "text": "(8999)未列入其它代码的其他专业服务",
      "value": "8999"
    }, {
      "text": "(6011)金融机构－自动现金支付",
      "value": "6011"
    }, {
      "text": "(6051)非金融机构－外币兑换、非电子转账的汇票、临时支付凭证和旅行支票",
      "value": "6051"
    }, {
      "text": "(5993)香烟雪茄专卖店",
      "value": "5993"
    }, {
      "text": "(5999)其他专门零售店",
      "value": "5999"
    }]
  }]
}, {
  "text": "民生类",
  "value": "A003",
  "children": [{
    "text": "加油、超市类",
    "value": "AC01",
    "children": [{
      "text": "(5411)大型仓储式超级市场大型仓储式超级市场",
      "value": "5411"
    }, {
      "text": "(5722)家用电器商店",
      "value": "5722"
    }, {
      "text": "(5542)自助加油站",
      "value": "5542"
    }, {
      "text": "(5541)加油站、服务站",
      "value": "5541"
    }]
  }, {
    "text": "交通运输售票",
    "value": "AC02",
    "children": [{
      "text": "(4111)本地和市郊通勤旅客运输（包括轮渡）",
      "value": "4111"
    }, {
      "text": "(4121)出租车服务",
      "value": "4121"
    }, {
      "text": "(4131)公路客运",
      "value": "4131"
    }, {
      "text": "(4511)航空公司",
      "value": "4511"
    }, {
      "text": "(4784)路桥通行费",
      "value": "4784"
    }, {
      "text": "(4112)铁路局指定票务代售点",
      "value": "4112"
    }, {
      "text": "(3998)铁路局（直属）",
      "value": "3998"
    }]
  }, {
    "text": "水电气缴费",
    "value": "AC03",
    "children": [{
      "text": "(9498)信用卡还款",
      "value": "9498"
    }, {
      "text": "(4900)公用事业 ",
      "value": "4900"
    }, {
      "text": "(5960)直销-保险直销",
      "value": "5960"
    }, {
      "text": "(6300)保险缴款(实际经营保险的公司)",
      "value": "6300"
    }, {
      "text": "(4814)电信服务，包括本地和长途电话（含固话、移动缴费类业务）",
      "value": "4814"
    }, {
      "text": "(4899)有线和其它付费电视服务",
      "value": "4899"
    }]
  }, {
    "text": "政府类",
    "value": "AC04",
    "children": [{
      "text": "(8651)政治组织（政府机构）",
      "value": "8651"
    }, {
      "text": "(9211)法庭费用，包括赡养费和子女抚养费",
      "value": "9211"
    }, {
      "text": "(9222)罚款",
      "value": "9222"
    }, {
      "text": "(9223)保释金",
      "value": "9223"
    }, {
      "text": "(9311)纳税",
      "value": "9311"
    }, {
      "text": "(9400)使领馆收费",
      "value": "9400"
    }, {
      "text": "(9399)未列入其他代码的政府服务",
      "value": "9399"
    }]
  }, {
    "text": "便民类",
    "value": "AC05",
    "children": [{
      "text": "(5994)报亭、报摊",
      "value": "5994"
    }, {
      "text": "(7523)停车场及车库",
      "value": "7523"
    }, {
      "text": "(9402)国家邮政服务",
      "value": "9402"
    }]
  }]
}, {
  "text": "公益类",
  "value": "A004",
  "children": [{
    "text": "公立医院、公立学校、慈善",
    "value": "AD01",
    "children": [{
      "text": "(8062)公立医院",
      "value": "8062"
    }, {
      "text": "(8211)初级和中等公立学校",
      "value": "8211"
    }, {
      "text": "(8220)公立大专院校",
      "value": "8220"
    }, {
      "text": "(8398)慈善和社会服务",
      "value": "8398"
    }]
  }]
}, {
  "text": "县乡优惠",
  "value": "A005",
  "children": [{
    "text": "系统默认",
    "value": "0",
    "children": [{
      "text": "(A001)餐娱类",
      "value": "A001"
    }, {
      "text": "(A002)一般类",
      "value": "A002"
    }, {
      "text": "(A003)民生类",
      "value": "A003"
    }, {
      "text": "(A004)公益类",
      "value": "A004"
    }, {
      "text": "(A005)县乡优惠",
      "value": "A005"
    }]
  }, {
    "text": "县乡优惠",
    "value": "AE01",
    "children": [{
      "text": "(9703)县乡优惠—宾馆餐饮娱乐类",
      "value": "9703"
    }, {
      "text": "(9704)县乡优惠—房产汽车类",
      "value": "9704"
    }, {
      "text": "(9705)县乡优惠—批发类",
      "value": "9705"
    }, {
      "text": "(9706)县乡优惠—超市加油类",
      "value": "9706"
    }, {
      "text": "(9707)县乡优惠—一般商户类",
      "value": "9707"
    }]
  }]
}]